module.exports = __webpack_public_path__ + "img/magnifying-glass.aebc951e.png";